import React, { Fragment } from 'react';
import { string, shape, array } from 'prop-types';
import Helmet from 'react-helmet';

import { Link } from 'react-router-dom';
import { Button, Tab } from 'semantic-ui-react';

import Heading from '~/views/common/Heading';
import TabGeneral from './TabGeneral';


const OrganizationView = ({
    data: {
        id,
        name,
        logo,
    },
    data,
}) => (
    <Fragment>
        <Helmet title={name} />

        <Heading
            header={name}
            subheader="Collab Portal"
            imageSrc={logo}
        >

            <Button
                as={Link}
                to={`/col/portals/${id}/edit`}
                color="blue"
                icon="pencil"
                content="Edit"
                labelPosition="right"
            />
        </Heading>

        <Tab panes={[
            {
                menuItem: 'General',
                render: () => <TabGeneral data={data} />,
            },
            {
                menuItem: 'Tab 2',
                render: () => <Tab.Pane>Tab 2 Content</Tab.Pane>,
            },
            {
                menuItem: 'Tab 3',
                render: () => <Tab.Pane>Tab 3 Content</Tab.Pane>,
            },
        ]}
        />
    </Fragment>
);

OrganizationView.propTypes = {
    data: shape({
        id: string.isRequired,
        name: string.isRequired,
        logo: string,
        licenses: array,
    }),
};

export default OrganizationView;
